import PageShell from "@/components/PageShell";
import { SponsorSection } from "@/components/SponsorShowcase";
import { useFooter } from "@/lib/useContent";
import { ArrowRight, Check, Trophy, Sparkles, Users } from "lucide-react";

const MATRIX = [
  { tier: "Gold", perks: ["Logo en hero + camiseta", "Presencia en toda la web", "Banner en Tienda", "Máxima exposición"], icon: Trophy, hl: true },
  { tier: "Silver", perks: ["Muro de sponsors", "Footer + banners", "Página de aliados"], icon: Sparkles, hl: false },
  { tier: "Partner", perks: ["Muro y footer", "Página de aliados", "Métricas de vistas"], icon: Users, hl: false },
];

export default function PatrocinadoresPage() {
  const contact = useFooter();
  const wa = (contact.whatsapp_sponsors || contact.whatsapp || "").replace(/\D/g, "");
  const WHATSAPP = `https://wa.me/${wa}?text=${encodeURIComponent("Hola! Quiero auspiciar al Club Comandante Leo Nowak")}`;
  return (
    <PageShell crumbs={[{ label: "Sponsors" }]}>
      {/* Hero */}
      <section className="relative bg-navy text-white overflow-hidden">
        <div className="absolute -top-24 -right-16 h-80 w-80 rounded-full bg-gold/15 blur-3xl" />
        <div className="absolute -bottom-24 -left-16 h-80 w-80 rounded-full bg-[#c0392b]/15 blur-3xl" />
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-20">
          <span className="section-tag section-tag--dark">Patrocinadores</span>
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white" style={{ fontFamily: "Outfit" }}>
            Nuestros Aliados
          </h1>
          <p className="mt-4 text-white/75 max-w-2xl text-base sm:text-lg">
            Marcas que acompañan al Club Comandante Leo Nowak y llegan a más de 800 familias socias y a toda la comunidad del barrio.
          </p>
          <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" data-testid="patrocinadores-cta"
             className="mt-8 inline-flex items-center gap-2 bg-gold text-navy font-bold px-8 py-4 rounded-xl hover:-translate-y-0.5 transition-transform shadow-lg">
            Convertite en Sponsor <ArrowRight className="h-5 w-5" />
          </a>
        </div>
      </section>

      {/* Matriz de niveles */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14" data-testid="patrocinadores-page">
        <h2 className="text-2xl sm:text-3xl font-black text-navy tracking-tight text-center" style={{ fontFamily: "Outfit" }}>
          Elegí cómo sumarte
        </h2>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {MATRIX.map((m) => (
            <div key={m.tier} className={`rounded-2xl p-6 border ${m.hl ? "bg-navy text-white border-gold/30 shadow-xl" : "bg-white text-navy border-navy/10 shadow-sm"}`}>
              <div className="flex items-center gap-2">
                <m.icon className="h-5 w-5 text-gold" />
                <span className="font-black" style={{ fontFamily: "Outfit" }}>{m.tier}</span>
                {m.hl && <span className="ml-auto text-[10px] font-bold uppercase bg-gold text-navy px-2 py-0.5 rounded-full">Exclusivo</span>}
              </div>
              <ul className="mt-4 space-y-2">
                {m.perks.map((p) => (
                  <li key={p} className={`flex items-start gap-2 text-sm ${m.hl ? "text-white/85" : "text-gray-600"}`}>
                    <Check className="h-4 w-4 text-gold shrink-0 mt-0.5" /> {p}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Showcase premium (reutiliza el componente de sponsors) */}
      <SponsorSection
        placement="page"
        eyebrow="Nuestros aliados"
        title="Marcas que confían en el club"
        subtitle="Empresas y comercios que eligen crecer junto a nuestra comunidad."
        ctaHref={WHATSAPP}
        ctaText="¿Tu empresa quiere crecer junto al club?"
        ctaLabel="Convertite en Sponsor"
      />
    </PageShell>
  );
}
